module.exports = "/_next/static/images/3e3ff4d6de2c2b53f1082ed3a664921a-woman-with-sandwich@0.75x.jpg.webp";